import React from "react";

export function KalkiLogo({ size = 34, showText = true }) {
  const base = process.env.PUBLIC_URL || "";
  return (
    <div className="flex items-center gap-2.5" data-testid="kalki-logo">
      <img
        src={`${base}/kalki-horse.png`}
        alt="KALKI AI"
        style={{ width: size, height: size, objectFit: "contain" }}
        className="drop-shadow-[0_0_12px_rgba(212,175,55,0.35)] select-none"
        draggable={false}
      />
      {showText && (
        <div className="leading-none">
          <div className="font-heading font-extrabold text-[15px] tracking-tight text-[#F5F5F5]">
            KALKI <span className="text-[#D4AF37]">AI</span>
          </div>
          <div className="text-[9px] tracking-[0.28em] text-[#737373] uppercase mt-0.5">Trade Terminal</div>
        </div>
      )}
    </div>
  );
}
